import { Product } from '@services/product/types/product';
import AppState from '../state';

const getYearPrice = (product: Product) =>
  product.prices.find((p) => p.frequency === 'year')?.value || 0;

export const productSelector = (
  products: Product[],
  categories: string[],
  hideFree?: boolean
) => {
  return products
    .filter((p) => categories.includes(p.category.toUpperCase()))
    .filter((p) => !hideFree || p.prices.some((f) => f.value > 0))
    .sort((a, b) => getYearPrice(a) - getYearPrice(b));

  // .sort((a, b) => (a.order || 0) - (b.order || 0));
};

export const plans = (products: Product[], hideFree?: boolean) => {
  return productSelector(products, ['PLAN'], hideFree);
};

export const getTracProPlan = (state: AppState) => {
  return state.products.list?.find((product) => {
    return (
      product.product_key === 'plan_trac_pro' && product.category === 'PLAN'
    );
  });
};

export const getProPlanPrice = (products: Product[]) => {
  let proPrice: any = 0;
  products.forEach((item) => {
    if (item.product_key === 'plan_pro') {
      item.prices?.forEach((price) => {
        if (price.frequency === 'year') {
          proPrice = price.value;
          proPrice = parseInt(proPrice) / (50 * 12);
        }
      });
    }
  });
  return proPrice;
};
export const getLabelPlanPrice = (products: Product[]) => {
  let proPrice: any = 0;
  products.forEach((item) => {
    if (item.product_key === 'plan_record_label_label') {
      item.prices?.forEach((price) => {
        if (price.frequency === 'year') {
          proPrice = price.value;
          proPrice = parseInt(proPrice) / (50 * 12);
        }
      });
    }
  });
  return proPrice;
};
export const recordLabelPlans = (products: Product[], hideFree?: boolean) => {
  return productSelector(products, ['PLAN_RECORD_LABEL'], hideFree);
};

export const getMerchPlan = (products: Product[]): Product | undefined => {
  const results = productSelector(products, ['PLAN_MERCH']);

  if (results.length) {
    return results[0];
  }
};
